/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable react/jsx-closing-bracket-location */
/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Menu, Tooltip } from '@mui/material';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { LanguageContext } from '../../../../../libs/Context';
import { BsFolder } from 'react-icons/bs';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Checkbox from '@mui/material/Checkbox';
import ReactPlayer from 'react-player';
import Avatar from '@mui/material/Avatar';
import AvatarGroup from '@mui/material/AvatarGroup';
import '../../../style.css';
import { MuiPaperPropsStyles, medaiDriveDateDiff } from '../../../../../libs/HelperContent';
import ListMenu from '../../CustomMenu/ListMenu';
import { MediaContext } from '../../..';
import MoveToFolder from '../../MoveToFolder';
import SharedInfo from './SharedInfo';
import { useParams } from 'react-router-dom';
import { RiDeleteBinLine } from 'react-icons/ri';
import GroupUserSvgIcon from '../../../../../assets/SvgIcons/GroupUserSvgIcon';
import RestorePopup from '../../../popups/RestorePopup';
import DeletePopUp from '../../../Common/DeletePopUp/DeletePopUp';
import MoveToTrashPopUp from '../../../Common/MoveToTrashPopUp/MoveToTrashPopUp';
import RenameFolder from './RenamePopUp';
import { useSelector } from 'react-redux';
import CommonVariableAndFunc from './CommonVariableAndFunc';
import SelectTemplate from '../../CustomEdmTemplates/SelectTemplate';
import CreationFieldPopUp from '../../../../NewsFeedRevised/Components/LeftPart/FeedCreation/CreationPopup';

const GridCard = (props) =>
{
	const { data, LoadMore, handleCheckBox, handleClickFolder, index, visibleFolderData,
		openShare, getFoldersData, isSelected	} = props;
	const { language } = useContext(LanguageContext);
	const { mediaState, tab, setClickedData } = useContext(MediaContext);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const [ optionsData, setOptionsData ] = useState<any>({});
	const [ anchorEl, setAnchorEl ] = React.useState<null | HTMLElement>(null);
	const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
	const lastFileElement = useRef(null);
	const [ popups, setPopups ] = useState<any>({
		move      : false,
		restore   : false,
		rename    : false,
		share     : false,
		trash     : false,
		delete    : false,
		customize : false
	});
	const { handleClose, handleOptions, fileType, extensionformat, documentCheck, defaultCheck } = CommonVariableAndFunc(data, setOptionsData, setAnchorEl);
	const [ mediaDrivePopup, setMediaDrivePopup ] = useState<any>([]);
	const [ onMouse, setOnMouse ] = useState(false);
	let shareArr:any;
	const clickedUser = useParams()?.userId || '';

	const handlePopup = (item) =>
	{
		setAnchorEl(null);
		setPopups({ ...popups, ...item });
	};

	if (userData?.empRole === 'employee')
	{
		shareArr = data?.shareTo?.filter((item:any) => (item?.type === 'employee' || item?.type === 'company internal employees') && item?.access !== 1);
	}
	else
	{
		shareArr = data?.shareTo?.filter((item:any) => item?.access !== 1);
	}

	useEffect(() =>
	{
		if (lastFileElement?.current)
		{
			const observer = new IntersectionObserver(
				([ entry ]) =>
				{
					if (entry.isIntersecting)
					{
						LoadMore();
					}
				},
				{
					root       : null,
					rootMargin : '0px',
					threshold  : 0.0
				}
			);

			if (lastFileElement.current)
			{
				observer.observe(lastFileElement.current);
			}

			return () =>
			{
				if (lastFileElement.current)
				{
					observer.unobserve(lastFileElement.current);
				}
			};
		}
	}, [ lastFileElement?.current, mediaState?.count ]);

	return (
		<>
			<div className='oneFourthWidth  pdngXS'>

				<button tabIndex={0} className={`flexCol fullHeight ${mediaState?.selectedData?.some((item) => item?.folderId === data?.folderId) ? 'selectMediaBg brdrprimarySM' : 'whiteBg'} positionRelative hoverEffectCard newsfeedShadow brdrRadiusSM pdngSM brdrBlackSM`}
					onMouseEnter={() => setOnMouse(true)}
					onMouseLeave={() => setOnMouse(false)}
					onKeyUp={(e) => { e.key === 'Enter' && setOnMouse(true); }}
				>
					{([ 0, 1, 3, 4 ]?.includes(tab) || (tab === 2 && clickedUser !== '')) &&
					<div className='flexInline mediaimgOverlay'>
						{ (onMouse || isSelected?.includes(data?.folderId)) &&
							<Checkbox
								checked={isSelected?.includes(data?.folderId)}
								onClick={() => handleCheckBox(data)}
								{...label} className='primaryTxt mrgnSM'
								style={{ height: 'var(--pixel40)' }}/>
						}
					</div>}

					<button tabIndex={0} className={`flexMinHeightCol mediaImgCntr ${(extensionformat !== 'zip' && tab !== 3) ? 'pointer' : ''} pdngHMD`}
						onKeyUp={() =>
{
							tab !== 3 && setClickedData(data);
							tab !== 3 && handleClickFolder(data);
						}}
						onClick={() =>
							{
							tab !== 3 && setClickedData(data);
							tab !== 3 && handleClickFolder(data);
							}}>
						{fileType !== 'video'
							? 	<LazyLoadImage
									src={data?.type === 0 || (tab === 2 && clickedUser === '') ? '/images/icons/folder.svg' : fileType === 'image' ? data?.media?.url : defaultCheck.includes(extensionformat) ? '/documents/blank.png' : `/documents/${extensionformat}.png`}
									alt='logo'
									className=''
									delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME}
									height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
									width={`${process.env.REACT_APP_IMG_WIDTH}%`}
									effect={process.env.REACT_APP_EFFECT}
								/>
							: !documentCheck.includes(extensionformat)
							?								<ReactPlayer url={data?.media?.url} className='reactPlayerWidth' width={'var(--percent100)'} height={'var(--percent100)'} />

							: (
								<LazyLoadImage
									src={`/documents/${extensionformat}.png`}
									alt='document'
									delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME} effect={process.env.REACT_APP_EFFECT} width={`${process.env.REACT_APP_IMG_WIDTH}%`} height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
								/>
							)
						}

					</button>
					{data?.shareTo?.length > 0 &&
						<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ share: true }); }} className='flexRow justifyEnd pdngVXS pointer' onClick={() => handlePopup({ share: true })}>
							<div className='flexAutoRow'>
								{/* // we need only three avatars remaining should be in more*/}
								<AvatarGroup>
									{shareArr.slice(0, 3)?.map((item:any) => (
										(item?.id[0] === 'R' || item?.type === 'company internal employees')
										? <Avatar key={item?.id[0]} alt='img' sx={{ width: 'var(--pixel30)', height: 'var(--pixel30)' }}>
											<GroupUserSvgIcon/>
										</Avatar>
										: <Avatar key={item?.id[0]} alt='img' src='/images/icons/defaultUser.svg' sx={{ width: 'var(--pixel30)', height: 'var(--pixel30)' }}/>
									))}

								</AvatarGroup>
								{shareArr?.length > 3 &&
									<div className='flexAutoRow alignCntr pdngLSM'>
										<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ share: true }); }} className='imgAvatarXS pointer brdrRadius50 moreTxtSM iconBlock' onClick={() => handlePopup({ share: true })}>
											<span className='fontWeight capitalTxt headingXSM'>+{shareArr?.length - 3}</span>
										</button>
									</div>
								}
							</div>
						</button>
					}
					<div className='flexRow alignCntr'>
						<div className='flexAutoRow'>
							{Object.keys(data)?.length > 0 &&
							(data?.type === 0 || (tab === 2 && clickedUser === ''))
                            ? <BsFolder className='primaryTxt' fontSize='var(--pixel24)'/>
							: <div className='imgAvatarXSM'>
								<LazyLoadImage

									src={defaultCheck.includes(extensionformat) ? '/documents/blank.png' : `/documents/${extensionformat}.png`}
									alt='document'
									delayTime={process.env.REACT_APP_PROFILE_DELAY_TIME} effect={process.env.REACT_APP_EFFECT} width={`${process.env.REACT_APP_IMG_WIDTH}%`} height={`${process.env.REACT_APP_IMG_HEIGHT}%`}
								/>
							</div>
                            }
						</div>
						<div className='flexMinWidthCol pdngHXS'>
							<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && tab !== 3 && handleClickFolder(data); }} className={`ellipsisTxt resFontMD ${(extensionformat !== 'zip' && tab !== 3) ? 'PrimaryHoverTxt primaryTxt pointer' : ''}`} onClick={() => tab !== 3 && handleClickFolder(data)}>
								{(tab === 2 && clickedUser === '') ? data?.ownerName : data?.name}
							</button>
							{tab !== 0 &&
								<Tooltip title={data?.uploadedBy} placement='top'>
									<p className='ellipsisTxt lightTxt headingSM firstLetter'>

										{(tab === 2 && clickedUser === '')
									? <span className='lightTxt'> {data?.count} Files</span>
									: <span className='lightTxt'>
										{tab === 1 ? `${language.sharedBy} ${data?.createdUser?.name}` : null}
										{/* #I3076 - added space between language and name */}
									</span>
								}
									</p>
								</Tooltip>
							}
							{([ 0, 1, 3 ]?.includes(tab) || (tab === 2 && clickedUser !== '')) &&
							<span className='minWidthDate lightTxt'>
								{/* &nbsp; */}
								{[ 0, 1, 2 ].includes(tab)
											? medaiDriveDateDiff(tab === 1 ? data?.sharedAt : data?.createdAt, new Date().valueOf())
											: medaiDriveDateDiff(data?.trashAt, new Date().valueOf())
										}
							</span>}
						</div>
						{([ 0, 1, 3, 4 ]?.includes(tab) || (tab === 2 && clickedUser !== '')) && <button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleOptions(e, data); }} className={`${(mediaState?.selectedData?.length >= 1) ? 'disableMode' : 'flexAutoRow pdngLXS pointer'}`} onClick={(event) => handleOptions(event, data)}>
							< MoreVertIcon />
						</button>}
						{(tab === 2 && clickedUser === '') && <button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && setOptionsData(data); handlePopup({ trash: true }); }} className='lightTxt pdngRSM pointer' onClick={() => { setOptionsData(data); handlePopup({ trash: true }); }}><RiDeleteBinLine fontSize={'var(--pixel22)'}/></button>}
					</div>
				</button>
				{(index === visibleFolderData?.length - 1) && <span ref={lastFileElement} /> }
			</div>

			{anchorEl && Object.keys(optionsData || {})?.length > 0 &&
				<Menu
					id='demo-positioned-menu'
					aria-label='demo-positioned-button'
					open={anchorEl && Boolean(Object.keys(optionsData || {})?.length > 0)}
					anchorEl={anchorEl}
					onClose={handleClose}
					PaperProps={{ MuiPaperPropsStyles }}
					transformOrigin={{
						vertical   : 'top',
						horizontal : 'right'
					}}
					anchorOrigin={{
						vertical   : 'bottom',
						horizontal : 'right'
					}}
				>
					<ListMenu setMediaDrivePopup={setMediaDrivePopup} openShare={openShare} data={data} tab={tab} popups={popups} handlePopup={handlePopup} setPopups={setPopups} optionsData={optionsData} setOptionsData={setOptionsData} getFoldersData={getFoldersData} setAnchorEl={setAnchorEl}/>
				</Menu>
			}
			{popups?.customize && <SelectTemplate handlePopup={handlePopup} popups={popups?.customize} from='edit' data={data} clickedUser={clickedUser}/>}
			{popups?.move && <MoveToFolder handlePopup={handlePopup} popups={popups} optionsData={data} />}
			{popups?.restore && <RestorePopup handlePopup={handlePopup} popups={popups} restoreData={[ optionsData ]} setOptionsData={setOptionsData} />}
			<button tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ share: false }); }} className={popups.share ? 'overlaySlider fadeInOverlay' : ''} onClick={() => handlePopup({ share: false })}/>
			<div className={popups.share ? 'flexCol fxdSocialMediaSlider slideIn whiteBg' : 'flexCol fxdSocialMediaSlider whiteBg'}>
				{popups.share && <SharedInfo sharedSliderClose={() => handlePopup({ share: false })} data={data}/>}
			</div>
			{popups?.delete && <DeletePopUp handlePopup={handlePopup} folderData={optionsData} getFoldersData={getFoldersData}/> }
			{popups?.trash && <MoveToTrashPopUp folderData={optionsData} handlePopup={handlePopup} />}
			{popups?.rename && <RenameFolder handlePopup={handlePopup} renameData={optionsData} popups={popups} setPopups={setPopups}/>}
			{mediaDrivePopup?.length > 0 &&
			// <NewCreatePopUp open={Boolean(mediaDrivePopup?.length > 0)} handleClose={() => setMediaDrivePopup(false)} mediaDrivePopup={mediaDrivePopup}/>}
			<CreationFieldPopUp
				OpenPop
				handleClosePop={() => setMediaDrivePopup(false)}
				requestT={'driveUpload'}
				externalFile={mediaDrivePopup}
			/>
			}

		</>
	);
};

export default GridCard;